import api from '@Services/api';
import { PermissionsResponse } from './permissions.res.types';

export const permissionsGetRequest = async (page: number, perPage: number) =>
	await api.post<PermissionsResponse>('permissions/all', {
		page,
		perPage,
	});
